import React, { useEffect, useState } from 'react';
import DeferPayment from "./DeferPayment";
import ReschedulePayment from "./ReschedulePayment";
import PaydownPayment from "./PaydownPayment";
import PayoffPayment from "./PayoffPayment";
import CreditPayment from "./CreditPayment";
import PaymentPlanPayment from "./payment_plan/PaymentPlanPayment";
import MakeupPayment from "./MakeupPayment";
import DiscountPayment from './DiscountPayment';
import { selectPaymentSchedulePanel } from '../../../redux/paymentSchedulePanelSlice'
import { useSelector } from 'react-redux'
import { selectModules } from '../../../redux/moduleSlice'

export default function PaymentScheduleSlider(props) {
  const { loanId, refreshPaymentSchedule, currentDate, navigateSlider, paymentId, customerInfo, outstandingTotal, promotions, loanInfo, isInResolutionWithoutPlan } = props;
  const paymentSchedulePanel = useSelector(selectPaymentSchedulePanel)
  const modules = useSelector(selectModules)
  const [paymentMethodHelperText, setPaymentMethodHelperText] = useState("");
  const [creditPaymentFields, setCreditPaymentFields] = useState({});

  useEffect(() => {
    if (modules.data.length > 0) {
      const leadModule = modules.data.find((e) => e.code_key === 'lead');
      const paymentModule = modules.data.find((e) => e.code_key === 'payment');

      if (leadModule) {
        const leadFields = [...leadModule.module_fields];

        leadFields.forEach((field) => {
          switch (field.column_name) {
            case 'payment_method_dropdown_option_id':
              setPaymentMethodHelperText(field.helper_text);
              break;
            default:
              break;
          }
        });
      }

      if (paymentModule) {
        const paymentFields = [...paymentModule.module_fields];
        const newCreditPaymentFields = {};

        paymentFields.forEach((field) => {
          switch (field.column_name) {
            case 'credit_reimbursement_amount':
              newCreditPaymentFields.creditReimbursementAmount = field.helper_text;
              break;
            case 'principal_amount':
              newCreditPaymentFields.principalAmount = field.helper_text;
              break;
            case 'interest_amount':
              newCreditPaymentFields.interestAmount = field.helper_text;
              break;
            case 'late_fee':
              newCreditPaymentFields.lateFee = field.helper_text;
              break;
            case 'nsf_fee':
              newCreditPaymentFields.nsfFee = field.helper_text;
              break;
            default:
              break;
          }
        });

        setCreditPaymentFields(newCreditPaymentFields);
      }
    }
  }, [modules.data]);

  const sliderStyle = {
    transition: 'max-height 0.5s ease-in-out',
    overflow: 'visible',
    // maxHeight: (paymentSchedulePanel.sliderName !== "") ? '3000px' : '0',
    height: (paymentSchedulePanel.sliderName !== "") ? 'auto' : '0',
    width: '100%',
  };

  return (
    <div style={sliderStyle}>
      <div className="lox-sub-module-sub-panel column is-full is-flex is-justify-content-space-between is-align-items-center has-background-light p-1 mb-0">
        <div style={{ width: "100%" }}>
          {paymentSchedulePanel.sliderName === 'defer' && <DeferPayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} />}
          {paymentSchedulePanel.sliderName === 'reschedule' && <ReschedulePayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} />}
          {paymentSchedulePanel.sliderName === 'paydown' && <PaydownPayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} />}
          {paymentSchedulePanel.sliderName === 'payoff' && <PayoffPayment key={paymentSchedulePanel.sliderName} promotions={promotions} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} />}
          {paymentSchedulePanel.sliderName === 'credit' && <CreditPayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} loanInfo={loanInfo} creditPaymentFields={creditPaymentFields} />}
          {paymentSchedulePanel.sliderName === 'payment_plan' && <PaymentPlanPayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} portfolioId={customerInfo.portfolio_id} outstandingTotal={outstandingTotal} isInResolutionWithoutPlan={isInResolutionWithoutPlan} />}
          {paymentSchedulePanel.sliderName === 'makeup' && <MakeupPayment key={paymentSchedulePanel.sliderName} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} customerInfo={customerInfo} paymentMethodHelperText={paymentMethodHelperText} />}
          {paymentSchedulePanel.sliderName === 'discount' && <DiscountPayment key={paymentSchedulePanel.sliderName} promotions={promotions} loanId={loanId} refreshPaymentSchedule={refreshPaymentSchedule} currentDate={currentDate} navigateSlider={navigateSlider} paymentId={paymentId} />}
        </div>
      </div>
    </div>
  )
}
